import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const InnerText = styled.p`
    ${FONTS.S};
    padding: 4px 0;
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    flex-wrap: nowrap;
    gap:12px;
    margin-top: 12px;
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-wrap: wrap;
    }
`;

export const WrapperFields = styled.div<{ isSelectOpen: boolean, phonesCount: number }>`
    margin: 16px 0;
    gap: 16px;
    // костыль из-за реализации компонента селектора 
    height: ${({ isSelectOpen, phonesCount })=> isSelectOpen ? `calc(${phonesCount} * 48px + 32px)` : 'auto'};
`;
